import ExploreMapPinInteraction from '../enums/ExploreMapPinInteraction';
import ExploreMapPinType from '../enums/ExploreMapPinType';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logExploreMapPinSelectedParams = {
  action_taken: ExploreMapPinInteraction;
  pin_type: ExploreMapPinType;
  trail_id?: number;
};

/**
 * User clicks or hovers on an explore map trail or trailhead pin
 * @param params - Attributes to log with the amplitude event
 * @param params.action_taken - The method by which the user interacted with a pin
 * @param params.pin_type - The type of pin that the user interacted with (trailhead or trail).
 * @param params.trail_id - The id of the trail
 */
const logExploreMapPinSelected = ({ action_taken, pin_type, trail_id }: logExploreMapPinSelectedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('explore map pin selected', { 'action taken': action_taken, 'pin type': pin_type, 'trail id': trail_id }, callback);
};

export default logExploreMapPinSelected;
